import {z} from '@hono/zod-openapi';

/** Languages the Price Report app is translated into (primary subtags). */
export const priceReportArgumentsLocaleSchema = z
  .enum(['cs', 'de', 'en', 'es', 'fr', 'it', 'nl', 'pl', 'sk'])
  .openapi('PriceReportArgumentsLocale');

export type PriceReportArgumentsLocale = z.infer<typeof priceReportArgumentsLocaleSchema>;
